import React from "react";
import MapBg from "../../../../../public/images/map-bg.svg";
import {Image} from "./VigoMapBG.styles";

export const VigoMapBG = () => {
    return <Image src={MapBg} alt="Vigo Map Background" />;
};
